<template>
  <table class="ks-is-fullwidth">
    <template v-for="(item, index) in items">
      <tr :key="index">
        <td colspan="100">
          <kst-value class="print-thermal-size" field="Name" :data="item" :catalog="ItemCatalog"/>
        </td>
      </tr>

      <tr :key="index+'a'">
        <td class="is-flex">
          <kst-value class="print-thermal-size ks-space-right"
            field="TotalRequestedQuantity" :data="item" :catalog="ItemCatalog"
          />
          <div class="ks-space-right">x</div>
          <kst-value class="print-thermal-size" field="DispatchSellPrice" :data="item" :catalog="ItemCatalog"/>
        </td>
        <td class="has-text-right">
          <kst-value class="print-thermal-size" field="TotalBruto" :data="item" :catalog="ItemCatalog"/>
        </td>
      </tr>

      <template v-if="item.DispatchSellPrice !== item.SellPrice">
        <tr :key="index+'b'">
          <td colspan="100">
            <div class="is-flex is-justify-content-right">
              <div class="ks-space-right">{{ ItemCatalog.DiscValue.Label }}</div>
              <kst-value class="print-thermal-size" field="DiscValue" :data="item" :catalog="ItemCatalog"/>
            </div>
          </td>
        </tr>
        <tr :key="index+'c'">
          <td colspan="100" class="has-text-right">
            <kst-value class="print-thermal-size" field="Price" :data="item" :catalog="ItemCatalog"/>
          </td>
        </tr>
      </template>
    </template>
  </table>
</template>

<script>
import ItemCatalog from "../PosItemCatalog.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    ItemCatalog: ItemCatalog
  })
}
</script>